export default __webpack_public_path__ + "static/media/Optocht bevrijdingsdag 5-05-2015-2.25fe183e.jpg";